import * as React from "react";
import { useParams } from "react-router-dom";

interface IUIState {
  groupId?: string;
  leftMenuActive: boolean;
  openLeftMenu: () => void;
  closeLeftMenu: () => void;
  toggleLeftMenu: () => void;
  setGroupId: (groupId?: string) => void;
}

const UIStateContext = React.createContext<IUIState>({
  groupId: undefined,
  setGroupId: () => {},

  leftMenuActive: false,
  openLeftMenu: () => {},
  closeLeftMenu: () => {},
  toggleLeftMenu: () => {},
});

function UIState({ children }: { children: React.ReactNode }) {
  const [groupId, setGroupId] = React.useState<string | undefined>();

  const [leftMenuActive, _changeLeftMenuActive] = React.useState(false);

  const state = React.useMemo(
    () => ({
      groupId,
      setGroupId,
      leftMenuActive,
      openLeftMenu: () => _changeLeftMenuActive(true),
      closeLeftMenu: () => _changeLeftMenuActive(false),
      toggleLeftMenu: () => _changeLeftMenuActive((v) => !v),
    }),
    [groupId, leftMenuActive]
  );

  return (
    <UIStateContext.Provider value={state}>{children}</UIStateContext.Provider>
  );
}

function useUIState() {
  return React.useContext(UIStateContext);
}

function PathParamsSynchronizer() {
  const { groupId } = useParams();
  const { setGroupId } = useUIState();

  React.useEffect(() => {
    setGroupId(groupId);
  }, [groupId, setGroupId]);

  return null;
}

export { UIState as default, useUIState, PathParamsSynchronizer };
